<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" :md="isSplitView ? 6 : 12">
        <SecretsList />
      </v-col>
      <v-col v-if="isSplitView" cols="12" md="6">
        <SecretsList />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SecretsList from "@/components/secrets/SecretsList.vue";

export default {
  name: "Secrets",
  components: {
    SecretsList,
  },
  computed: {
    isSplitView() {
      return this.$store.getters["user/getSplitView"];
    },
  },
};
</script>
